export default __webpack_public_path__ + "static/media/D2R.45d93f92.png";